import { blue, blue_100, blue_200, blue_300, blue_400, blue_600, gray, gray_100, gray_400, gray_500, gray_600, gray_900, gray_950, magenta, magenta_600, orange, orange_100, orange_200, orange_300, orange_400, orange_700, orange_800, orange_900, red, red_100, red_200, red_300, red_400, red_500, red_600, red_700, red_800, red_900, steel_blue, steel_blue_300, steel_blue_900, teal, teal_100, teal_200, teal_300, teal_400, teal_600, teal_700, teal_800, teal_900, white, yellow, yellow_300, yellow_400 } from '@panwds/constants';
import { CATEGORY_1_SHIFT_DARK_COLORS, CATEGORY_1_SHIFT_LIGHT_COLORS, CATEGORY_1_UNIQUE_COLORS, CATEGORY_1_UNIQUE_DARK_COLORS, CATEGORY_1_UNIQUE_LIGHT_COLORS, CATEGORY_2_SHIFT_DARK_COLORS, CATEGORY_2_SHIFT_LIGHT_COLORS, CATEGORY_2_UNIQUE_COLORS, CATEGORY_2_UNIQUE_DARK_COLORS, CATEGORY_2_UNIQUE_LIGHT_COLORS } from './category_palette.js';
import { colors } from './tokens/color.js';
export { black, white } from '@panwds/constants';
export const overlay = '#1F2733';
export const transparent = 'transparent';
export const BRAND_COLORS = {
    panw: '#FA582D',
    strata: '#FFCB06',
    prisma: '#00C0E8',
    cortex: '#00CC66',
    unit42: '#C84727'
};
/**
 * @deprecated
 */
export const visScaleA = {
    100: '#303866',
    200: '#4E296C',
    300: '#742D7D',
    400: '#903280',
    500: '#A22C75',
    600: '#CA386A',
    700: '#EB5757'
};
/**
 * @deprecated
 */
export const visScaleB = {
    100: '#661300',
    200: '#A62F0C',
    300: '#D95221',
    400: '#FF7B41',
    500: '#FF9A42',
    600: '#FFC74F',
    700: '#FFDE65'
};
/**
 * @deprecated
 */
export const visScaleC = {
    100: '#1D7918',
    200: '#088D10',
    300: '#3EAE15',
    400: '#81C42E',
    500: '#AFD620',
    600: '#D6E31B',
    700: '#FFDE65'
};
/**
 * @deprecated
 */
export const visScaleD = {
    100: '#357387',
    200: '#45959A',
    300: '#49A392',
    400: '#28C2A6',
    500: '#3ED6BA',
    600: '#7CE9CC',
    700: '#C5F5E9'
};
/**
 * @deprecated
 */
export const visScaleE = {
    100: '#282F78',
    200: '#26418D',
    300: '#1F75B2',
    400: '#2C95C7',
    500: '#5DB8E4',
    600: '#7AC8ED',
    700: '#BCE4FA'
};
export const error = {
    DEFAULT: red,
    /**
     * @deprecated
     */
    light: red_300,
    /**
     * @deprecated
     */
    lighter: red_200,
    /**
     * @deprecated
     */
    lightest: red_100,
    /**
     * @deprecated
     */
    dark: red_700,
    /**
     * @deprecated
     */
    darker: red_800,
    /**
     * @deprecated
     */
    darkest: red_900
};
export const warning = {
    DEFAULT: orange,
    /**
     * @deprecated
     */
    light: orange_200,
    /**
     * @deprecated
     */
    lighter: orange_200,
    /**
     * @deprecated
     */
    lightest: orange_100,
    /**
     * @deprecated
     */
    dark: orange_700,
    /**
     * @deprecated
     */
    darker: orange_800,
    /**
     * @deprecated
     */
    darkest: orange_900
};
export const success = {
    DEFAULT: teal,
    /**
     * @deprecated
     */
    light: teal_300,
    /**
     * @deprecated
     */
    lighter: teal_200,
    /**
     * @deprecated
     */
    lightest: teal_100,
    /**
     * @deprecated
     */
    dark: teal_700,
    /**
     * @deprecated
     */
    darker: teal_800,
    /**
     * @deprecated
     */
    darkest: teal_900
};
export const primary = {
    DEFAULT: blue,
    /**
     * @deprecated
     */
    light: blue_300,
    /**
     * @deprecated
     */
    lighter: blue_200,
    /**
     * @deprecated
     */
    lightest: blue_100
};
export const PRIORITY_COLORS = {
    blocker: magenta,
    error: red,
    warning: orange,
    caution: yellow
};
export const severityColors = {
    critical: magenta,
    high: red,
    medium: orange,
    low: yellow,
    lowest: yellow_300,
    success: teal,
    information: blue,
    confirmation: teal,
    /**
     * @deprecated
     */
    blocker: PRIORITY_COLORS.blocker,
    /**
     * @deprecated
     */
    error: PRIORITY_COLORS.error,
    /**
     * @deprecated
     */
    warning: PRIORITY_COLORS.warning,
    /**
     * @deprecated
     */
    caution: PRIORITY_COLORS.caution
};
export const riskColors = {
    pass: teal_400,
    '1': yellow_300,
    '2': yellow_400,
    warning: orange_400,
    '3': orange_400,
    '4': red_500,
    fail: red_500,
    '5': magenta_600,
    critical: magenta_600
};
/**
 * @deprecated this variable. Should use individual variables directly if needed.
 */
export const baseColors = {
    ...colors,
    overlay,
    error,
    warning,
    success,
    primary,
    risk: riskColors,
    severity: severityColors,
    priority: PRIORITY_COLORS,
    ['vis-a']: visScaleA,
    ['vis-b']: visScaleB,
    ['vis-c']: visScaleC,
    ['vis-d']: visScaleD,
    ['vis-e']: visScaleE
};
export const iconColor = {
    gray: gray,
    red: red,
    orange: orange,
    yellow: yellow,
    teal: teal,
    blue: blue,
    ['blue-steel']: steel_blue
};
export const textColor = {
    ...baseColors,
    default: gray_900,
    primary: {
        DEFAULT: gray_900,
        dark: gray_100
    },
    secondary: {
        DEFAULT: gray_600,
        dark: gray_400
    },
    hint: {
        DEFAULT: gray_500,
        dark: gray_500
    },
    disabled: {
        DEFAULT: gray,
        dark: gray_600
    },
    link: {
        DEFAULT: blue_600,
        dark: blue_400
    },
    success: {
        DEFAULT: teal_600,
        dark: teal_400
    },
    error: {
        DEFAULT: red_600,
        dark: red_400
    },
    'category-1-shift-light': CATEGORY_1_SHIFT_LIGHT_COLORS,
    'category-1-shift-dark': CATEGORY_1_SHIFT_DARK_COLORS,
    'category-1-unique': CATEGORY_1_UNIQUE_COLORS,
    'category-1-unique-light': CATEGORY_1_UNIQUE_LIGHT_COLORS,
    'category-1-unique-dark': CATEGORY_1_UNIQUE_DARK_COLORS,
    'category-2-shift-light': CATEGORY_2_SHIFT_LIGHT_COLORS,
    'category-2-shift-dark': CATEGORY_2_SHIFT_DARK_COLORS,
    'category-2-unique': CATEGORY_2_UNIQUE_COLORS,
    'category-2-unique-light': CATEGORY_2_UNIQUE_LIGHT_COLORS,
    'category-2-unique-dark': CATEGORY_2_UNIQUE_DARK_COLORS,
    ['dark-bg']: {
        DEFAULT: white,
        secondary: gray_500,
        disabled: gray_600,
        hint: gray_400,
        link: blue_300,
        red: red_400,
        orange: orange_300,
        yellow: yellow_300,
        teal: teal_300,
        blue: blue_300,
        ['blue-steel']: steel_blue_300
    },
    risk: riskColors,
    icon: iconColor
};
export const BACKGROUND_COLORS = {
    default: {
        DEFAULT: gray_100,
        dark: gray_950
    }
};
export const navBackground = steel_blue_900;
//# sourceMappingURL=colors.js.map